import React from 'react'
import { observer } from 'mobx-react-lite'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { uiStore } from 'shared/store/uiStore'
import { TimePicker } from 'shared/ui'
import { useScheduleDateFiledContext } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/context/sendLaterContext'
import styles from './styles.module.scss'

export const DateContent = observer(({ dropdownId }: { dropdownId: string }) => {
  const { dateFieldDate, setDateFieldDate } = useScheduleDateFiledContext()

  return (
    <TimePicker
      selected={dateFieldDate}
      onChange={setDateFieldDate}
      parentsDropdownId={[dropdownId]}
      textFieldPlaceholderProps={{
        className: styles.picker,
        variant: 'outline',
        effect: 'collapse',
        rightActions: [
          makeTextFieldIcon({
            icon: 'chevronDown',
            color: 'var(--content-neutral-primary)',
          }),
        ],
      }}
      offsetMinutes={uiStore.offsetMinute}
      triggerTooltipProps={{
        label: 'Date',
        placement: 'left',
        fullWidth: true,
      }}
    />
  )
})
